import {ADICIONAR_FILTRO_CUPOM, LISTAR_FILTROS_CUPOM, REMOVER_FILTRO_CUPOM} from '../../actions/types'
import {filtroExiste} from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosCupom = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_CUPOM: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_CUPOM: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}

export const filtrosCupom = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_CUPOM: {
      return action.payload.data
    }
    default:
      return state
  }
}
